/** Platform marketing (multi-tenant SaaS shell). */
export const PLATFORM_NAME = "Distribution Prime";
export const PLATFORM_TAGLINE = "Professional distribution management for bottlers and distributor networks";
export const PLATFORM_CONSOLE_LOGIN_PATH = "/platform/login";
export const PLATFORM_CONSOLE_PATH = "/platform";
export const PLATFORM_DESCRIPTION =
  "Run your own isolated workspace with distributors, orders, targets, shipping, and reports — without sharing data with other companies.";
